function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { logger } from '@src/logger';
import { LibAction } from '../core/action';
import { Buffer, AggregationBuffer } from '../core/buffer';
import { ConsumerService } from '../core/consumer';
import { Constants } from '../../../utils/constants';
import * as httpProtocol from '../../http/httpProtocol';
import { getAppConfig } from '../../init/appConfig';
import { getNetworkStats } from '@shared/utils/appUtils';
import { getWindow } from '@shared/services/window';
const PUBLISH_RETRY_COUNT = 2;
class TelemetryActions extends LibAction {
    initSystemInfo(probeName, service) {
        service.systemInfo.correlationId = getAppConfig('correlationId');
    }
    loggerFlush(probeName, service) {
        const buffer = service.buffer;
        const events = [];
        if (buffer && buffer.getSize() > 0) {
            while(!buffer.isEmpty()){
                const event = buffer.pop().data;
                events.push(event);
            }
            const correlationId = getAppConfig('correlationId');
            const telemetryPayload = {
                events: events,
                correlationId: correlationId
            };
            service.action.publishTelemetryEvent(telemetryPayload);
        }
    }
    logEvent(probeName, service, payload) {
        const event = service.createDebugEvent(payload);
        service.action.pushRecordInBuffer(probeName, service, event, payload.flushLog);
    }
    logAndFlushEvent(probeName, service, payload) {
        const event = service.createDebugEvent(payload);
        service.action.pushRecordInBuffer(probeName, service, event, true);
    }
    logUserSystemInfo(probeName, service, locale) {
        const screenResolution = {
            Width: screen.width,
            Height: screen.height,
            PixelRatio: window.devicePixelRatio ? window.devicePixelRatio : 0
        };
        const browser = service.action.detectBrowser().split(' ');
        const browserInfo = {
            Browser: browser[0],
            version: browser[1]
        };
        const data = {
            'Screen Resolution': screenResolution,
            'Browser Info': browserInfo,
            Locale: locale,
            connection: getNetworkStats()
        };
        const obj = {
            page: '',
            action: Constants.Telemetry.Action.UserSettings,
            actionModifier: 'Info',
            details: JSON.stringify(data)
        };
        const event = service.createDebugEvent(obj);
        service.action.pushRecordInBuffer(probeName, service, event, false);
        logger.info(obj.details, {
            action: obj.action,
            actionModifier: obj.actionModifier,
            page: obj.page
        });
    }
    logOneTimeInfo(probeName, service, payload) {
        const obj = {
            page: '',
            action: payload.eventName,
            actionModifier: payload.actionModifier ? payload.actionModifier : 'Info',
            details: payload.data,
            isFeedback: payload.isFeedback ? payload.isFeedback : false
        };
        const event = service.createDebugEvent(obj);
        service.action.pushRecordInBuffer(probeName, service, event, payload.flushLog);
    }
    publishTelemetryEvent(telemetryPayload) {
        const outEvents = {
            TelemetryEvents: telemetryPayload.events
        };
        const serializedEvents = JSON.stringify(outEvents);
        const options = {
            authenticationType: httpProtocol.AuthenticationTypes.Unauthenticated,
            retry: PUBLISH_RETRY_COUNT
        };
        const { region } = getAppConfig('config');
        httpProtocol.post('/api/log', options).setData(serializedEvents).setHeader(Constants.Headers.CorrelationId, telemetryPayload.correlationId).setHeader(Constants.Headers.XMSClientRegion, region).request().then(()=>{
            console.log('[Success] Telemetry Logs submitted successfully');
        }, (err)=>{
            console.log('[Fail] Telemetry Log failed : ' + err);
        });
    }
    detectBrowser() {
        const ua = navigator.userAgent;
        let tem;
        let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) {
                return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
        }
        M = M[2] ? [
            M[1],
            M[2]
        ] : [
            navigator.appName,
            navigator.appVersion,
            '-?'
        ];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return M.join(' ');
    }
    pushRecordInBuffer(probeName, service, event, flushLog) {
        const record = {
            provider: 'static',
            probe: probeName,
            time: new Date().getTime(),
            data: event
        };
        service.buffer.push(record);
        if (service.buffer.getSize() > service.maxBufferSize || flushLog) {
            service.action.loggerFlush(probeName, service);
        } else {
            // let's start a timer to flush the buffer
            // this will help safeguard against never reaching the maxBufferSize
            // and risk not storing anything at all
            service.action.startBufferTimer(probeName, service);
        }
    }
    startBufferTimer(probeName, service) {
        var _getWindow_setTimeout, _getWindow;
        const flushTimer = 30000; // 30 seconds
        if (this.timeoutID > -1) {
            window.clearTimeout(this.timeoutID);
            this.timeoutID = -1;
        }
        this.timeoutID = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_setTimeout = _getWindow.setTimeout) === null || _getWindow_setTimeout === void 0 ? void 0 : _getWindow_setTimeout.call(_getWindow, ()=>{
            // flush the buffer if we have anything in it
            if (service.buffer.getSize() > 0) {
                service.action.loggerFlush(probeName, service);
            }
            this.timeoutID = -1;
        }, flushTimer);
    }
    constructor(...args){
        super(...args), _define_property(this, "timeoutID", -1);
    }
}
export class SpzaTelemetryService extends ConsumerService {
    createDebugEvent(obj) {
        const event = {
            page: obj.page ? obj.page : '',
            action: obj.action ? obj.action : '',
            actionModifier: obj.actionModifier ? obj.actionModifier : '',
            clientTimestamp: new Date().toISOString(),
            appName: obj.appName ? obj.appName : '',
            product: obj.product ? obj.product : -1,
            featureFlag: obj.featureFlag ? obj.featureFlag : '',
            details: obj.details ? obj.details : '',
            oid: this._tenantInfo && this._tenantInfo.oid ? this._tenantInfo.oid : '',
            tid: this._tenantInfo && this._tenantInfo.tid ? this._tenantInfo.tid : '',
            spzaId: this._spzaId ? this._spzaId : '',
            mshash: this._trailId ? this._trailId : '',
            hostType: this._hostType ? this._hostType : '',
            isFeedback: obj.isFeedback ? obj.isFeedback : false
        };
        return event;
    }
    registerProbes() {
        const p = this.instrumentService.getProvider('static');
        if (p) {
            p.enableProbe('initSystemInfo', this, this.action.initSystemInfo);
            p.enableProbe('logTelemetryInfo', this, this.action.logEvent);
            p.enableProbe('logAndFlushTelemetryInfo', this, this.action.logAndFlushEvent);
            p.enableProbe('flushTelemetryInfo', this, this.action.loggerFlush);
            // These are one time telemetry events
            p.enableProbe('logUserSystemInfo', this, this.action.logUserSystemInfo);
            p.enableProbe('logOneTimeInfo', this, this.action.logOneTimeInfo);
        }
    }
    registerSpzaId(spzaId) {
        this._spzaId = spzaId;
    }
    registerTrailId(trailId) {
        this._trailId = trailId;
    }
    registerTenantInfo(oid, tid) {
        this._tenantInfo.oid = oid;
        this._tenantInfo.tid = tid;
    }
    registerHostType(hostType) {
        this._hostType = hostType;
    }
    constructor(instrumentService, isClient){
        const name = isClient ? 'client telemetry' : 'server telemetry';
        super(name, instrumentService), _define_property(this, "buffer", void 0), _define_property(this, "action", void 0), _define_property(this, "systemInfo", void 0), _define_property(this, "host", void 0), _define_property(this, "maxBufferSize", void 0), _define_property(this, "_spzaId", void 0), _define_property(this, "_trailId", void 0), _define_property(this, "_tenantInfo", void 0), _define_property(this, "_hostType", void 0);
        this._spzaId = '';
        this._trailId = '';
        this._tenantInfo = {
            oid: '',
            tid: ''
        };
        this._hostType = '';
        if (isClient) {
            this.action = new TelemetryActions();
            this.buffer = new Buffer(150);
            // This is the maximum number of records stored in the buffer before flushing
            this.maxBufferSize = 20;
            this.aggregation = new AggregationBuffer();
            if (instrumentService) {
                this.systemInfo = instrumentService.systemInfo;
            }
            this.registerProbes();
        }
    }
}
